import React from 'react'
import weddingsaree from "../images/2 Model Wedding.jpg";
import Banarasisaree_wedding from "../images/banarasi saree wedding.jpg"
import Weddingsareecollection from "../images/WEDDING BANARASI SAREE.jpg";
import Banarasisaree from "../images/WEDDING COLLECTION.jpg";

import Banarasisareenew from "../images/WEDDING saree Banarasi.jpg";
import WEDDINGsareefamily from "../images/WEDDING family design.jpg";
import pre_wedding from "../images/Pre-Wedding Product at Balaji saree.jpg";


function WeddingSaree() {
    return (
        <div>
    



            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-3 mt-3">
                            <div className="card-group">
                                <div className="card">
                                    <img src={weddingsaree} className="card-img-top" alt="weddingsaree" />
                                    <div className="card-body">
                       <h5 style={{ color: "#873f08" }} className="card-title">Wedding Saree</h5>
                                        <p className="card-text">More Wedding Saree Available at Balaji Saree (RANAGHTA | BETHUADAHARI | KARIMPUR)</p>
                                        <a href='tel: 7501445023'>
                                        <p style={{ color: "#562500" }} className="card-text"><small>Book Now <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                        </svg></small></p></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 mt-3">
                            <div className="card-group">
                                <div className="card">
                                    <img src={Banarasisaree_wedding} className="card-img-top" alt="Banarasisaree_wedding" />
                                    <div className="card-body">
                            <h5 style={{ color: "#873f08" }} className="card-title">Wedding Saree</h5>
                                        <p className="card-text">More Wedding Saree Available at Balaji Saree (RANAGHTA | BETHUADAHARI | KARIMPUR)</p>
                                        <a href='tel: 7501445023'>
                                        <p style={{ color: "#562500" }} className="card-text"><small>Book Now <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                        </svg></small></p></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 mt-3">
                            <div className="card-group">
                                <div className="card">
                                <img src={Weddingsareecollection} className="card-img-top" alt="Weddingsareecollection"/>
                                    <div className="card-body">
                              <h5 style={{ color: "#873f08" }} className="card-title">Wedding Saree</h5>
                                        <p className="card-text">More Wedding Saree Available at Balaji Saree (RANAGHTA | BETHUADAHARI | KARIMPUR)</p>
                                        <a href='tel: 7501445023'>
                                        <p style={{ color: "#562500" }} className="card-text"><small>Book Now <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                        </svg></small></p></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 mt-3">
                            <div className="card-group">
                                <div className="card">
                                    <img src={Banarasisaree} className="card-img-top" alt="Banarasisaree_wedding" />
                                    <div className="card-body">
  <h5 style={{ color: "#873f08" }} className="card-title">Wedding Saree</h5>
                                        <p className="card-text">More Wedding Saree Available at Balaji Saree (RANAGHTA | BETHUADAHARI | KARIMPUR)</p>
                                        <a href='tel: 7501445023'>
                                        <p style={{ color: "#562500" }} className="card-text"><small>Book Now <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                        </svg></small></p></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 mt-3">
                            <div className="card-group">
                                <div className="card">
                                    <img src={Banarasisareenew} className="card-img-top" alt="Banarasisaree_wedding" />
                                    <div className="card-body">
                                       <h5 style={{ color: "#873f08" }} className="card-title">Wedding Saree</h5>
                                        <p className="card-text">More Wedding Saree Available at Balaji Saree (RANAGHTA | BETHUADAHARI | KARIMPUR)</p>
                                        <a href='tel: 7501445023'>
                                        <p style={{ color: "#562500" }} className="card-text"><small>Book Now <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                        </svg></small></p></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 mt-3">
                            <div className="card-group">
                                <div className="card">
                                    <img src={WEDDINGsareefamily} className="card-img-top" alt="Banarasisaree_wedding" />
                                    <div className="card-body">
                                       <h5 style={{ color: "#873f08" }} className="card-title">Wedding Shopping</h5>
                                        <p className="card-text">More Wedding Collection Available at Balaji Saree (RANAGHTA | BETHUADAHARI | KARIMPUR)</p>
                                        <a href='tel: 7501445023'>
                                        <p style={{ color: "#562500" }} className="card-text"><small>Book Now <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                        </svg></small></p></a>
                                    </div>
                                </div>
                            </div>
                        </div>


                         <div className="col-md-3 mt-3">
                            <div className="card-group">
                                <div className="card">
                                    <img src={pre_wedding} className="card-img-top" alt="pre_wedding"/>
                                    <div className="card-body">
                                        <h5 style={{ color: "#873f08" }} className="card-title">Pre-Wedding</h5>
                                        <p className="card-text">More Pre-Wedding Collection Available at Balaji Saree (RANAGHTA | BETHUADAHARI | KARIMPUR)</p>
                                        <a href='tel: 7501445023'>
                                        <p style={{ color: "#562500" }} className="card-text"><small>Book Now <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                        </svg></small></p></a>
                                    </div>
                                </div>
                            </div>
                        </div>

                      



                    </div>
                </div>
            </div>
        </div>
    )
}

export default WeddingSaree